import { formatDecimal } from '@findy-code/utils/decimal';
import type { JobDescriptionBasicSalary } from '@findy-code/yuffie/graphql';

export const basicSalaryEnumTmp = {
  MONTHLY: '月給',
  YEARLY: '年俸',
  NON_DISCLOSURE: '非開示',
};

export const salaryTextWithUnit = (
  salary: number | null | undefined,
  ratio = 1,
  unitText = '円'
) => {
  return salary
    ? `${formatDecimal(salary * ratio, {
        maximumFractionDigits: 0,
      })}${unitText}`
    : '';
};

export const salaryRangeText = (
  salaryMin: number | null | undefined,
  salaryMax: number | null | undefined,
  ratio = 1,
  unitText = '円'
) => {
  if (!salaryMin && !salaryMax) return '';

  return `${salaryTextWithUnit(
    salaryMin,
    ratio,
    unitText
  )} 〜 ${salaryTextWithUnit(salaryMax, ratio, unitText)}`.trim();
};

export const salaryRangeTextWithType = (
  salaryMin: number | null | undefined,
  salaryMax: number | null | undefined,
  basicSalaryType: JobDescriptionBasicSalary | null | undefined
) => {
  if (basicSalaryType === 'NON_DISCLOSURE') return '※';
  if (!salaryMin && !salaryMax) return '';

  return `${
    basicSalaryType ? basicSalaryEnumTmp[basicSalaryType] : ''
  } ${salaryRangeText(salaryMin, salaryMax)}`.trim();
};
